import { JSX } from 'react';
import './title.css';

interface TitleInputProps {
    title: string,
    setTitle: (title: string) => void
}

const TitleInput = ({title, setTitle}: TitleInputProps): JSX.Element => {
    
    return (
        <input
          className="title-input"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Add a new todo"
      />
    ); 
  };
    
  export default TitleInput;